import global from '@/util/mixin/global'

export default {
  mixins:[global],
  props:['value'],
  data(){
    return {
      currentValue:null
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv === null || (Array.isArray(nv) && nv.length ==0)){
        this.currentValue = null
      }
    })

    // if( this.isCompany && this.subjectId ){
    //   this.currentValue = (this.subject.lever+10)+'@'+this.subjectId
    //   console.log('this.currentValue',this.currentValue)
    // }
  },
  methods:{
    handleCompanyChange(v){
      let publicData
      if( v.collection ){
        publicData = v.children
      }else{
        publicData = [v.value]
      }
      this.$emit('input',publicData)
      this.$emit('change',publicData)
      this.$emit('change-data',v)
    },
  },
  render(){
    return <sl-company-cascader collection placeholder="请选择单位" on-change-data={this.handleCompanyChange} v-model={this.currentValue} />
  }
}